import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import All_products from "../../common-components/all-products/All_products";
import "./Product_Image.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

const Product_Image = () => {
    const { id } = useParams();
    const product = All_products.find((p) => p.id === parseInt(id));

    // ✅ Always declare hooks before any conditional returns
    const [isClicked, setIsClicked] = useState(false);
    const [currentImage, setCurrentImage] = useState(
        "/assets/images/explore/top-products/product2.png" // Default first image
    );
    const [swiperInstance, setSwiperInstance] = useState(null);
    const zoomableRef = useRef(null);

    const toggleHeartColor = () => {
        setIsClicked(!isClicked);
    };

    // Zoomable class
    class Zoomable {
        constructor(element, config) {
            this.element = element;
            this.config = this._mergeConfig(config);

            const { initialZoom, minZoom, maxZoom } = this.config;

            this.zoomed = false;
            this.initialZoom = Math.max(Math.min(initialZoom, maxZoom), minZoom);
            this.zoom = this.initialZoom;

            this.img = element.querySelector(".zoomable__img");
            this.img.draggable = false;
            this.element.style.setProperty("--zoom", this.initialZoom);

            this._addEventListeners();
        }

        static get Default() {
            return Default;
        }

        _addEventListeners() {
            this.element.addEventListener("mouseenter", () =>
                this._handleMouseover()
            );
            this.element.addEventListener("mousemove", (evt) =>
                this._handleMousemove(evt)
            );
            this.element.addEventListener("mouseleave", () =>
                this._handleMouseout()
            );
            this.element.addEventListener("wheel", (evt) => this._handleWheel(evt));
        }

        _handleMouseover() {
            if (this.zoomed) return;
            this.element.classList.add("zoomable--zoomed");
            this.zoomed = true;
        }

        _handleMousemove(evt) {
            if (!this.zoomed) return;
            const elPos = this.element.getBoundingClientRect();
            const percentageX = `${((evt.clientX - elPos.left) * 100) / elPos.width}%`;
            const percentageY = `${((evt.clientY - elPos.top) * 100) / elPos.height}%`;
            this.element.style.setProperty("--zoom-pos-x", percentageX);
            this.element.style.setProperty("--zoom-pos-y", percentageY);
        }

        _handleMouseout() {
            if (!this.zoomed) return;
            this.element.style.setProperty("--zoom", this.initialZoom);
            this.element.classList.remove("zoomable--zoomed");
            this.zoomed = false;
        }

        _handleWheel(evt) {
            if (!this.zoomed) return;
            evt.preventDefault();
            const newZoom = this.zoom + evt.deltaY * (this.config.zoomSpeed * -1);
            const { minZoom, maxZoom } = this.config;
            this.zoom = Math.max(Math.min(newZoom, maxZoom), minZoom);
            this.element.style.setProperty("--zoom", this.zoom);
        }

        _mergeConfig(config) {
            return {
                ...this.constructor.Default,
                ...(typeof config === "object" ? config : {}),
            };
        }
    }

    const Default = {
        initialZoom: 3,
        minZoom: 1.25,
        maxZoom: 4,
        zoomSpeed: 0.01,
    };

    useEffect(() => {
        const element = zoomableRef.current;
        if (!element) return;
        const zoomable = new Zoomable(element);

        return () => {
            element.removeEventListener("mouseenter", zoomable._handleMouseover);
            element.removeEventListener("mousemove", zoomable._handleMousemove);
            element.removeEventListener("mouseleave", zoomable._handleMouseout);
            element.removeEventListener("wheel", zoomable._handleWheel);
        };
    }, []);

    if (!product) {
        return <h2>Product Not Found</h2>;
    }

    const images = [
        { image: "/assets/images/explore/top-products/product2.png" },
        { image: "/assets/images/explore/top-products/product1.png" },
        { image: "/assets/images/explore/top-products/product2.png" },
        { image: "/assets/images/explore/top-products/product1.png" },
        { image: "/assets/images/explore/top-products/product2.png" },
        { image: "/assets/images/explore/top-products/product1.png" },
    ];

    return (
        <div className="Product_Image">
            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <div className="img_main_container">
                        <div className="product-detail text-center">
                            <div className="specs" ref={zoomableRef}>
                                <img
                                    src={product?.image}
                                    className="zoomable__img"
                                    alt="Selected"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="col-lg-12 col-md-12">
                    <div className="main">
                        <div className="sidebar-swiper">
                            <Swiper
                                slidesPerView={"auto"}
                                modules={[Navigation, Autoplay]}
                                breakpoints={{
                                    0: { slidesPerView: 3, spaceBetween: 10 },
                                    380: { slidesPerView: 4, spaceBetween: 10 },
                                    485: { slidesPerView: 5, spaceBetween: 10 },
                                    575: { slidesPerView: 5, spaceBetween: 5 },
                                    768: { slidesPerView: 5, spaceBetween: 10 },
                                    992: { slidesPerView: 4, spaceBetween: 10 },
                                    1024: { slidesPerView: 4, spaceBetween: 10 },
                                    1200: { slidesPerView: 5, spaceBetween: 10 },
                                    1440: { slidesPerView: 6, spaceBetween: 10 },
                                    2000: { slidesPerView: 6, spaceBetween: 10 },
                                }}
                                navigation
                                pagination={{ clickable: true }}
                                className="mySwiper category_slider product_image_slider"
                                onSwiper={(swiper) => setSwiperInstance(swiper)}
                            >
                                {images.map((item, index) => (
                                    <SwiperSlide key={index}>
                                        <div
                                            className="gallery-imgs"
                                            onClick={() => setCurrentImage(item.image)}
                                        >
                                            <img
                                                src={process.env.PUBLIC_URL + item.image}
                                                className="inner-img"
                                                alt={`Image ${index + 1}`}
                                            />
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div> */}

                
            </div>
        </div>
    );
};

export default Product_Image;
